/* esm.sh - date-fns@4.1.0/formatISODuration */
function $(t){let{years:o=0,months:n=0,days:r=0,hours:s=0,minutes:e=0,seconds:u=0}=t;return`P${o}Y${n}M${r}DT${s}H${e}M${u}S`}var a=$;export{a as default,$ as formatISODuration};
//# sourceMappingURL=formatISODuration.mjs.map